import { jsx as _jsx } from "react/jsx-runtime";
import { Children, isValidElement, useMemo } from 'react';
import { Routes } from 'react-router-dom';
import { useSettingsMenu } from 'components/settings/components/menu/hooks/useSettingsMenu';
export function SecuredSettingsRoutes({ children, }) {
    const settingsMenu = useSettingsMenu();
    const allowedRoutes = useMemo(() => settingsMenu.reduce((routes, section) => [
        ...routes,
        ...section.items.map((x) => x.route.replace('/settings/', '')),
    ], []), [settingsMenu]);
    return (_jsx(Routes, { children: Children.map(children, (childRoute) => {
            if (!isValidElement(childRoute)) {
                return null;
            }
            const path = childRoute.props['path'];
            // Allow catch all route
            if (path === '*') {
                return childRoute;
            }
            return allowedRoutes.some((ar) => path.startsWith(ar))
                ? childRoute
                : null;
        }) }));
}
